import { apiV2 } from "api/firebase";

/*
 * The SDK's `ShowInfoLibraryGateway`, re-exported so the feature keeps one
 * import site (FS-2890).
 */
const { showInfoLibrary } = apiV2;

export default showInfoLibrary;
